// extracted by mini-css-extract-plugin
export default {"tag":"NetworkPriceStatusTag_tag__bWhlx"};